<template>
	<div id="home-values">
		<div class="container">
			<div class="row text-center">
				<div class="col-12">
					<h2 class="main-title headline-l">
						{{ $t('homeScreen.values.title') }}
					</h2>
					<p class="subtitle text-l">
						{{ $t('homeScreen.values.subtitle') }}
					</p>
				</div>
			</div>
			<div class="row values-row">
				<div
					v-for="(value, index) in valuesList"
					:key="index"
					class="col-lg-4 col-12 value-item"
				>
					<div class="icon-wrapper">
						<img :src="value.icon" :alt="value.title" />
					</div>
					<h3 class="value-title">{{ value.title }}</h3>
					<p class="value-description text-m">{{ value.description }}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'HomeValues',
	props: {},
	components: {},
	data: () => ({}),
	created() {},
	computed: {
		valuesList() {
			return [
				{
					icon: '/images/icons/safety-blue.svg',
					title: this.$t('homeScreen.values.safeguard.title'),
					description: this.$t('homeScreen.values.safeguard.description'),
				},
				{
					icon: '/images/icons/hand-coin.svg',
					title: this.$t('homeScreen.values.easyUse.title'),
					description: this.$t('homeScreen.values.easyUse.description'),
				},
				{
					icon: '/images/icons/future-blue.svg',
					title: this.$t('homeScreen.values.access.title'),
					description: this.$t('homeScreen.values.access.description'),
				},
			];
		},
	},
	methods: {},
};
</script>

<style lang="scss" scoped>
#home-values {
	padding: 80px 0;
	border-bottom: 1px solid #6464ff;

	@media (max-width: $breakpoint-md) {
		padding: 60px 0;
	}

	.container {
		@media (min-width: $breakpoint-lg) {
			max-width: 1196px;
		}
	}

	.main-title {
		color: $black;
		text-transform: uppercase;
		margin-bottom: 24px;
		font-weight: 700;
        text-align: left;

		@media (max-width: $breakpoint-md) {
			font-size: 32px;
			line-height: 38px;
            text-align: center;
		}

		@media (max-width: $breakpoint-sm) {
			font-size: 28px;
			line-height: 34px;
		}
	}

	.subtitle {
		color: $black;
		margin-bottom: 54px;
        text-align: left;
		@media (max-width: $breakpoint-md) {
			margin-bottom: 40px;
            text-align: center;
		}
	}

	.values-row {
		display: flex;
		justify-content: space-between;
		align-items: flex-start;

		@media (max-width: $breakpoint-md) {
            justify-content: center;
            align-items: center;
            gap: 20px;
		}

		@media (max-width: $breakpoint-sm) {
			flex-direction: column;
		}
	}

	.value-item {
		display: flex;
		flex-direction: column;
		align-items: start;
		text-align: start;
        max-width: 350px;
        margin-top: 20px;

        @media (max-width: $breakpoint-md) {
            align-items: center;
            text-align: center;
            max-width: 390px;
        }

		@media (max-width: $breakpoint-sm) {
			margin-bottom: 20px;
		}
	}

	.icon-wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 14px;

		img {
			width: 48px;
			height: 48px;
			object-fit: contain;
		}
	}

	.value-title {
		color: $black;
		font-size: 20px;
		font-weight: 700;
		font-family: 'HKNova-Bold', sans-serif;
		margin-bottom: 16px;
		text-transform: uppercase;
		letter-spacing: 0.5px;
	}

	.value-description {
		color: $black;
		line-height: 24px;
		max-width: 380px;
	}
}
</style>
